<template>
  <div class="layout-container">
    <NavHeader></NavHeader>
    <div
      class="main"
      :style="{ marginLeft: !isShowAutocomplete ? '0' : '16vw' }"
    >
      <div v-if="isShowAutocomplete" class="content-left">
        <div class="menu-title">{{ texts.helpDocument }}</div>
        <sideMenu
          :menuList="menutree"
          @changeBlog="changeBlog"
          :currentId="
            selectedLanguage === 'zh'
              ? '' + currentBlogId
              : '' + currentEnglishBlogId
          "
        />
      </div>
      <div class="container-right" v-if="blogKey">
        <router-view />
      </div>
    </div>
  </div>
</template>

<script>
import { mapState, mapMutations } from "vuex"
import sideMenu from "@/components/sideMenu"
import NavHeader from "@/components/header"
import Blog from "@/views/Blog"

export default {
  components: { sideMenu, Blog, NavHeader },
  data() {
    return {
      logoIcon: require("@/assets/icons/logo.svg"),
      searchIcon: require("@/assets/icons/search.svg"),
      globeIcon: require("@/assets/icons/globe.svg"),
      isButtonVisible: false,
      searchkey: "",
      blogKey: Math.random().toString(),
    }
  },
  computed: {
    ...mapState([
      "title",
      "registerIcon",
      "menulist",
      "menutree",
      "currentBlogId",
      "currentEnglishBlogId",
      "selectedLanguage",
      "texts",
    ]),
    isShowAutocomplete() {
      return this.$route.name !== "Dashboard"
    },
  },
  watch: {
    $route: {
      handler(val) {
        if (val.query.blogid) {
          this.SET_CURRENTBLOG(val.query.blogid)
          this.SET_CURRENTENGLISHBLOG(val.query.blogid)
        }
        this.blogKey = Math.random().toString()
      },
      immediate: true,
    },
  },
  methods: {
    ...mapMutations(["SET_CURRENTBLOG", "SET_CURRENTENGLISHBLOG"]),
    changeBlog(e) {
      this.$router.push({
        path: "/blog",
        query: {
          blogid: e,
        },
      })
    },
  },
}
</script>
<style lang="scss" scoped>
.layout-container {
  height: calc(100vh - 72px);
  .main {
    height: 100%;
    margin-left: 16vw;
    .content-left {
      min-width: 16vw;
      max-width: 16vw;
      box-sizing: border-box;
      padding: 0 24px;
      background: #ffffff;
      overflow-y: auto;
      overflow-x: hidden;
      height: calc(100vh - 72px);
      position: fixed;
      left: 0;
      top: 72px;
      border-right: 1px solid #efefef;
      &::-webkit-scrollbar {
        width: 7px;
      }
      &::-webkit-scrollbar-thumb {
        border-radius: 5px;
        box-shadow: inset 0 0 5px rgba(0, 0, 0, 0.03);
        background: rgba(0, 0, 0, 0.2);
      }
      &::-webkit-scrollbar-track {
        box-shadow: inset 0 0 5px rgba(0, 0, 0, 0.03);
        border-radius: 0;
        background: rgba(0, 0, 0, 0.1);
      }

      .menu-title {
        margin: 23px 0 12px 0;
        font-size: 15px;
        color: #10121666;
      }
    }
    .container-right {
      height: 100%;
      flex-grow: 1;
      // overflow-y: auto;
    }
  }
}
</style>
